import { lazyWithSuspense } from '~/utilities/lazyWithSuspense';
import { LoadingState } from './LoadingState';

export const AnonymousProject = lazyWithSuspense(async () => import('./AnonymousProjectScreen'), {
  loadingState: <LoadingState />,
});
